import { mount } from 'svelte';
import '@fontsource-variable/open-sans/wght.css';
import '@fontsource-variable/azeret-mono/wght.css';
import '@fontsource-variable/frank-ruhl-libre/wght.css';
import '@fontsource-variable/caveat/wght.css';
import '@fontsource-variable/kablammo/morf.css';
import './frontend.scss';
import Frontend from './Frontend.svelte';

// -
const target = document.getElementById('frontend');
if (!target) throw new Error('No frontend target');

const frontend = mount(Frontend, { target });

export default frontend;
